<template>
  <div></div>
</template>

<script>
  import runtimeConfig from '@/common/runtime-config';

  import { clearPkceData, loadPkceData } from '@/modules/auth/utils/pkce';

  let isExchanging = false;

  export default {
    name: 'Callback',
    async created() {
      const { code, state, error } = this.$route.query;

      if (error) {
        clearPkceData();
        this.$router.push({ name: 'ErrorPage' });
        return;
      }

      if (!code || !state) {
        this.$router.push({ name: 'Login' });
        return;
      }

      if (isExchanging) return;
      isExchanging = true;

      const pkceData = loadPkceData(state);
      if (!pkceData) {
        isExchanging = false;
        this.$router.push({ name: 'ErrorPage' });
        return;
      }

      try {
        await this.$store.dispatch('auth/oidc/exchangeCode', {
          clientId: runtimeConfig.oidc.clientId,
          code,
          codeVerifier: pkceData.codeVerifier,
          redirectUri: runtimeConfig.oidc.redirectUri,
        });

        clearPkceData();
        const returnUrl = sessionStorage.getItem('oidc_return_url') || '/';
        sessionStorage.removeItem('oidc_return_url');
        this.$router.push(returnUrl);
      } catch {
        clearPkceData();
        this.$router.push({ name: 'ErrorPage' });
      } finally {
        isExchanging = false;
      }
    },
  };
</script>
